import React, { useState, useEffect } from 'react';
import StudioLogo from '../../../../assets/svg/signIn_logos/studioLogo.svg';
import UniPhoreLogo from '../../../../assets/svg/signIn_logos/uniphore.svg';

import Dots from '../../../../assets/svg/signIn_logos/Dots.svg';
import DotsAnimated from '../../../../assets/svg/signIn_logos/dot_animated.svg'
import FirstImg from '../../../../assets/svg/signIn_logos/first_img.svg';
import SecondImg from '../../../../assets/svg/signIn_logos/second_img.svg';
import ThirdImg from '../../../../assets/svg/signIn_logos/third_img.svg';
import FourthImg from '../../../../assets/svg/signIn_logos/fourth_img.svg';
import './carousel.css';

const carouselData = [
    {
        image: FirstImg,
        title: 'Build Apps Effortlessly',
        description: 'Use Uniphore’s visual low-code platform to effortlessly build robust applications, boosting your business efficiency.',
    },
    {
        image: SecondImg,
        title: 'Streamline Workflows',
        description: 'Streamline your tasks! The Uniphore platform lets you seamlessly automate processes, saving you valuable time and money.',
    },
    {
        image: ThirdImg,
        title: 'Visual Low-Coding',
        description: 'Limited coding know-how? No problem! Uniphore’s visual low-code platform empowers you to build the application you need.',
    },
    {
        image: FourthImg,
        title: 'Launch Your Application',
        description: 'Ready to go live? Uniphore simplifies the app deployment process, making it easy to manage and scale as your business thrives.',
    },
];

const Carousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
        }, 5000);
        return () => {
            clearInterval(timer);
        };
    }, []);

    // Function to handle dot click and change the current slide
    const handleDotClick = (index: any) => {
        setCurrentIndex(index);
    };

    return (
        <div className="authcarousel-container">
            <div className="logo">
                <img src={UniPhoreLogo} style={{height:"88px", width:"200px"}}  alt="A8Studio_logo" />
            </div>
            <div className="authcarousel-wrapper">
                <div className="authcarousel-images">
                    <img src={DotsAnimated} style={{height:"379px", width:"423px", borderRadius:"5px"}} alt="dots" />
                    {carouselData.map((items, index) => {
                        return (
                            <React.Fragment key={index} >
                                {currentIndex == index && <img key={index} style={{height: "230px"}} className={`${currentIndex == index ? "cards_popUp_anim" : "cards_popDown_anim"}`}
                                    src={items.image} alt="alt-img" />}
                            </React.Fragment>
                        )
                    })}
                </div>
                {carouselData.map((items, index) => {
                    let width = currentIndex === 0 ? "73%" : currentIndex === 1 ? "68%" : "70%"
                    return (
                        <React.Fragment key={index}>
                            {currentIndex == index  && <div className={`${currentIndex == index && "content-fadeIn"} authcarousel-content`}>
                                <div className='content-wrapper'>
                                    <div className="authcarousel-title">{carouselData[ currentIndex ].title}</div>
                                    <div style={{width}} className="authcarousel-description">{carouselData[ currentIndex ].description}</div>
                                </div>
                            </div>
                            }
                        </React.Fragment>
                    )
                })}
            </div>
            <div className="authcarousel-dots">
                {carouselData.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => handleDotClick(index)}
                        className={`authcarousel-dot ${index === currentIndex ? 'active' : ''}`}
                    ></div>
                ))}
            </div>
        </div>
    );
};

export default Carousel;
